import axios, { AxiosResponse } from "axios";
import { TGetConvergenceData } from "./types";
import { RESOURCE_ENDPOINT } from "./config";
import { setApiUrl } from "api/helpers";

export const getConvergence = async (contentId: string[]): Promise<AxiosResponse<TGetConvergenceData[]>> => {
  const url = setApiUrl(RESOURCE_ENDPOINT + `/${contentId.join(',')}`)
  return axios.get(url)
}